<template>
  <div class="card">
    <div class="pb-0 card-header mb-0">
      <h6>Community/Society</h6>
    </div>
    <div class="p-3 card-body">
      <div class="chart">
        <canvas id="social" class="chart-canvas" height="300"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted, reactive, watch } from "vue";
import Chart from "chart.js/auto";

export default {
  name: "GradientLineChart",
  props: {
    esgSA2022: {
      type: Number,
    },

    esgSA2021: {
      type: Number,
    },

    esgSA2020: {
      type: Number,
    },
  },

  setup(props) {
    const chartLine = reactive({
      esgSA2022: props.esgSA2022,
      esgSB2022: props.esgSB2022,
      esgSA2021: props.esgSA2021,
      esgSB2021: props.esgSB2021,
      esgSA2020: props.esgSA2020,
      esgSB2020: props.esgSB2020,
    });
    let chartInstance = null;
    const updateChart = () => {
      if (chartInstance) {
        chartInstance.data.datasets[0].data = [
          props.esgSA2020,
          props.esgSA2021,
          props.esgSA2022,
        ];
        chartInstance.update();
      }
    };

    watch(
      () => [props.esgSA2020, props.esgSA2021, props.esgSA2022],
      function () {
        chartLine.esgSA2022 = props.esgSA2022;
        chartLine.esgSA2021 = props.esgSA2021;
        chartLine.esgSA2020 = props.esgSA2020;

        updateChart();
      },
      { immediate: true }
    );

    const createChart = () => {
      const canvas = document.getElementById("social");
      if (canvas) {
        const ctx = canvas.getContext("2d");

        const gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
        gradientStroke.addColorStop(1, "rgba(94, 114, 228, 0.2)");
        gradientStroke.addColorStop(0.2, "rgba(94, 114, 228, 0.0)");
        gradientStroke.addColorStop(0, "rgba(94, 114, 228, 0)");

        chartInstance = new Chart(ctx, {
          type: "line",
          data: {
            labels: ["2020", "2021", "2022"],
            datasets: [
              {
                label: "Amount invested",
                tension: 0.4,
                borderWidth: 2,
                pointRadius: 0,
                borderColor: "#11cdef",
                backgroundColor: gradientStroke,
                fill: true,
                data: [props.esgSA2020, props.esgSA2021, props.esgSA2022], // Sample data for ESG Rating
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              title: {
                display: true,
                text: "Total investment in communities",
                color: "#ffffff",
              },
              legend: {
                display: false,
              },
            },
            interaction: {
              intersect: false,
              mode: "index",
            },
            scales: {
              y: {
                grid: {
                  drawBorder: true,

                  display: true,
                  drawOnChartArea: true,
                  drawTicks: true,
                },
                ticks: {
                  display: true,
                  color: "#ffffff",
                },
                color: "#ffffff",
                title: {
                  display: true, // Set to true to display the x-axis title
                  text: "Money Invested (RM)",
                  color: "#ffffff",
                  font: {
                    size: 9, // Set the font size for the x-axis title
                  },
                },
              },

              x: {
                grid: {
                  drawBorder: true,
                  borderColor: "#ffffff",
                  borderWidth: 0.3,
                  display: false,
                  drawOnChartArea: false,
                  drawTicks: false,
                  borderDash: [5, 5],
                },
                ticks: {
                  display: true,
                  color: "#fbfbfb",
                  padding: 20,
                  font: {
                    size: 11,
                    family: "Open Sans",
                    style: "normal",
                    lineHeight: 2,
                  },
                },
              },
            },
          },
        });
      }
    };

    onMounted(() => {
      createChart();
    });

    onUnmounted(() => {
      if (chartInstance) {
        chartInstance.destroy();
        chartInstance = null;
      }
    });

    return { chartLine, updateChart };
  },
};
</script>